'use strict';

import jsCookie from 'js-cookie';

import queryString from '../helpers/queryString.js';

export function getUnintializedExperiment() {
    return {
        expId: 'none',
        variant: -1,
    }
}

// state is common to frontend Reflux and moodboard Redux
// Shape:
//    name strint
//    expId string
//    variant int
export function getExperiment(state) {
    // https://www.en.advertisercommunity.com/t5/Google-Optimize-Experiment/Get-variant-id-from-Javascript/td-p/1226726
    const qs = queryString();

    // Only for mood-board; use ?variant=n to lock to MB variant (internal use only)
    if (qs.variant) {
        jsCookie.set('DISABLE_GA', 1, {
            domain: Payload.release.frontend_host,
            expires: 365
        });
        return {
            expId: 'override',
            variant: parseInt(qs.variant),
        }
    }

    if (state && state.experiment && state.experiment.expId != 'none') {
        return state.experiment;
    }

    // utm_expid is set by Optimize (could also be done with query param `expId` from experiment settings)
    if (qs.utm_expid) {
        // Example: .zTXkJU7oSAyMTnbzO6n3Aw.2  where zTX... is the experiment ID and 2 is the variant
        const groups = qs.utm_expid.match(/^\.(.+)\.(\d)$/);
        if (groups) {
            const expId   = groups[1],
                  variant = groups[2];
            // Returns Redux store object for moodboard.save.metrics.experiment
            return {
                expId,
                variant: parseInt(variant)
            };
        }
    }

    return getUnintializedExperiment();
}



// WEBPACK FOOTER //
// /home/eric/projects/com.strongproject/repos/platforms/common-js/content-experiments/Experiments.js